import { useState, useEffect, useRef } from "react";

/**
 * Progreso de scroll (0..1) de una sección "alta" con contenido sticky.
 * 0 = el tope de la sección llega al tope del viewport.
 * 1 = el final de la sección llega al final del viewport.
 * Usa requestAnimationFrame para ir suave y respeta reduce-motion.
 */
export function useSectionProgress() {
  const ref = useRef(null);
  const [p, setP] = useState(0);

  useEffect(() => {
    let raf = 0;
    const compute = () => {
      raf = 0;
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const total = rect.height - vh; // distancia scrolleable mientras está sticky
      const scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      setP(total > 0 ? scrolled / total : 0);
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(compute);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    compute();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return [ref, p];
}

export default useSectionProgress;
